module.exports = __webpack_public_path__ + "static/media/4.cbc57c63.jpg";